import { Boolean, Number, Record, Static, String, Union } from "runtypes";

import { OrgRoleLiteral } from "./enums.js";
import { OrgId, UserId } from "./idTypeBrands.js";

export const AuthenticatedUserOrgDetails = Record({
  userId: UserId,
  id: OrgId,
  displayName: String,
  orgRole: OrgRoleLiteral,
  email: String,
  userCount: Number.optional(),
  // The org's user-facing URL handle, used as the URL segment when present.
  // Optional so older servers (which omit it) still validate; falls back to id.
  userFacingId: String.optional(),
});

export type AuthenticatedUserOrgDetails = Static<
  typeof AuthenticatedUserOrgDetails
>;

export const UnAuthenticatedUserOrgDetails = Record({
  id: OrgId,
  displayName: String,
  email: String,
  ssoEnforced: Boolean,
  // See AuthenticatedUserOrgDetails.userFacingId.
  userFacingId: String.optional(),
});

export type UnAuthenticatedUserOrgDetails = Static<
  typeof UnAuthenticatedUserOrgDetails
>;

export const UserOrgDetails = Union(
  AuthenticatedUserOrgDetails,
  UnAuthenticatedUserOrgDetails,
);

export type UserOrgDetails = Static<typeof UserOrgDetails>;
